export default __webpack_public_path__ + "static/media/VI.9a911f84.svg";